// extracted by mini-css-extract-plugin
export default {"list":"SwitchWallet_list__RB+40","wallet":"SwitchWallet_wallet__7h3JL","active":"SwitchWallet_active__arBwe"};